module.exports = __webpack_public_path__ + "images/application/ss-ac-action@2x-67b31cdf.jpg";